// extracted by mini-css-extract-plugin
module.exports = {"center":"styles_center__zTGJf","text":"styles_text__1FX61"};